function init() {
    if ($(".warning-list").length > 0) {
        initWarnings();
    }
}

window.initWarnings = () => {
    $('.hvd-state-change i').click(function(event) {
        var url = '/Handler/HvD/Pegel';
        var $el = $(this);
        var state = $el.attr('data-state');
        var $station = $el.closest('.row');
        switch ($station.attr('data-type')) {
            case 'P': // Pegelsation
                url = '/Handler/HvD/Pegel';
                break;
            case 'T': // Talsperre
                url = '/Handler/HvD/Talsperre';
                break;
            case 'W': // Wetterstation
                url = '/Handler/HvD/Pegel';
                break;
            case 'ST': // Stadt
                url = '/Handler/HvD/Stadt';
                break;
            case 'G': // Stadt
                url = '/Handler/HvD/Gewaesser';
                break;
            case 'SE': // Sensor
                url = '/Handler/HvD/Sensor';
                break;
        }
        $.ajax({
            cache: false,
            type: "POST",
            url: url,
            data: {
                data: {
                    pegel: $station.attr('data-id'),
                    type: $station.attr('data-type'),
                    action: 'pubwar',
                    value: state
                }
            }
        }).done(function(data) {
            if (data === 'OK') {
                $el.parent().find('i').removeClass('active');
                $el.addClass('active');
            }
        });

    });
}
init();
